import axios from 'axios'
import camelCase from 'lodash.camelcase'
import { prefixUrl, dateReviver } from 'utils'

export enum types {
  GET_COURSES = 'courses.GET_COURSES',
  GET_DETAILS = 'courses.GET_DETAILS',
}
const SERVICE_ENDPOINT = '/Curriculum/ClientService.ashx'
const METADATA_SERVICE_ENDPOINT = prefixUrl('/Services/Commerce/items.ashx')

const requestHeaders = { 'x-lms-json-serialize': 'camel,indent,nonull' }

export function getMyCourses() {
  return {
    type: types.GET_COURSES,
    payload: axios({
      method: 'get',
      url: SERVICE_ENDPOINT,
      headers: requestHeaders,
    })
      .then(checkForDisappointment)
      .then(response => {
        const coursesByStatus = response.data.items
        const allCourses = Object.entries(coursesByStatus).reduce((acc, [_k, v]) => {
          acc = acc.concat(v)
          return acc
        }, [])
        return allCourses
      })
      .then(allCourses => {
        return allCourses.map(course => {
          return JSON.parse(JSON.stringify(course), dateReviver)
        })
      })
      .then(checkSerialization)
  }
}

export function getCourseDetails(userCurriculumAssignmentId) {
  return {
    type: types.GET_DETAILS,
    payload: axios({
      method: 'get',
      url: `${SERVICE_ENDPOINT}/${userCurriculumAssignmentId}`,
      headers: requestHeaders,
    })
      .then(response => response.data.items)
      .then(items => items[0])
      .then(item => {
        return JSON.parse(JSON.stringify(item), dateReviver)
      })
      .then(checkSerialization)
  }
}

function checkForDisappointment(response) {
  const { success, error } = response.data
  // ಠ_ಠ
  if(typeof success !== 'undefined' && !success) {
    if(error) {
      throw new Error(error)
    }
    throw new Error('An unspecified error occurred on the server.')
  }
  return response
}

function checkSerialization(resp: object): object;
function checkSerialization(resp: object[]): object[];
function checkSerialization(resp): any {
  const obj = Array.isArray(resp) ? resp[0] : resp
  if(!obj) {
    return resp
  }
  if(obj.name) {
    return resp
  }
  if(obj.Name) {
    throw new Error('Improperly serialized course JSON received.')
  }
  return resp
}
